// client/editor/presets/full-editor.ts
import { DeleteSelectedNodeMenuItem } from "../../menu-items/DeleteSelectedNode.js";
import { accordeonConfigs } from "../../nodes/accordeon.js";
import { box } from "../../nodes/box.js";
import { button } from "../../nodes/button.js";
import { excalidraw } from "../../nodes/excalidraw.js";
import { file } from "../../nodes/file.js";
import { flex } from "../../nodes/flex.js";
import { grid } from "../../nodes/grid/config.js";
import { gridCell } from "../../nodes/grid/grid-cell/config.js";
import { hardBreak } from "../../nodes/hard-break.js";
import { icon } from "../../nodes/icon.js";
import { iconText, iconWrapper, textWrapper } from "../../nodes/iconText.js";
import { iframe } from "../../nodes/iframe.js";
import { image } from "../../nodes/image.js";
import { section } from "../../nodes/section.js";
import { spacing } from "../../nodes/spacing.js";
import { tag } from "../../nodes/tag.js";
import { vimeo } from "../../nodes/vimeo.js";
import { youtube } from "../../nodes/youtube.js";
import { richTextEditorConfig } from "./rich-text-editor.js";
var fullEditorConfig = (props) => [
  ...richTextEditorConfig(props),
  // custom nodes (buildify)
  ...accordeonConfigs(),
  button(),
  excalidraw(),
  file(),
  flex(),
  grid(),
  gridCell(),
  hardBreak(),
  icon(),
  iconText(),
  iconWrapper(),
  textWrapper(),
  image(),
  section(),
  spacing(),
  tag(),
  vimeo(),
  youtube(),
  iframe(),
  box(),
  {
    menuItems: [DeleteSelectedNodeMenuItem]
  }
];
export {
  fullEditorConfig
};
